module.exports = __webpack_public_path__ + "static/media/DubaiW23-Medium.5540b192.ttf";